import nxModule from 'nxModule';

const templateUrl = require('./user-predicate.template.html');

class UserPredicate {
  constructor(accessRuleService) {
    this.type = 'USER_ACCESS_MODE';
    this.accessRuleService = accessRuleService;
  }

  $onInit() {
    this.inputDefinitions = this.accessRuleService.getInputDefinitionSelection(this.ruleDefinitions, this.type);
    this.inputDefinition = this.accessInput;
    this.value = this.predicates[this.type][this.inputDefinition];
  }

  valueChanged() {
    this.predicates[this.type][this.inputDefinition] = this.value;
  };

  inputDefinitionChanged() {
    if (this.inputDefinition !== this.accessInput && this.predicates[this.type].hasOwnProperty(this.accessInput)) {
      delete this.predicates[this.type][this.accessInput];
      this.valueChanged();
    }
  }
}

nxModule.component('userPredicate', {
  templateUrl,
  bindings: {
    predicates: '=',
    ngDisabled: '<',
    ruleDefinitions: '<',
    accessInput: '<'
  },
  controller: UserPredicate
});
